import getTid from '@utils/getTid';
import { fetchTourData } from '@apis/tourApis';
import domain from '../domain';
import dataHandler from '../utils/dataHandler';

const fetchData = domain.effect(async () => {
  const data = await fetchTourData(getTid());
  dataHandler(data);
  return data;
});

export default fetchData;
